(function () {
'use strict';
var FAQS = {
'perfil-olfativo-hayat': [
{
q: 'Qual \u00e9 o cheiro exato do Hayat?',
a: 'O Hayat \u00e9 um frutal tropical luminoso. Abre com manga suculenta e lim\u00e3o vibrante, com pimenta rosa e gengibre conferindo um "picante suave". O cora\u00e7\u00e3o traz cumarina azul e jasmim \u2014 uma combina\u00e7\u00e3o cremosa e levemente herbal. O fundo de madeiras secas e \u00e2mbar fecha com calor e profundidade. Resultado: solar, quente e levemente ex\u00f3tico.'
},
{
q: 'Hayat \u00e9 mais para homem ou mulher?',
a: '\u00c9 uma fragr\u00e2ncia predominantemente feminina ou unissex. O car\u00e1ter tropical-cremoso tende a ser mais associado ao p\u00fablico feminino, mas qualquer pessoa que goste de frutais quentes pode us\u00e1-lo com confian\u00e7a.'
},
{
q: 'Quanto tempo o Hayat dura na pele?',
a: 'Com \u00e2mbar e madeiras secas na base, o Hayat tem boa fixa\u00e7\u00e3o: 8\u201310h na pele. Na roupa, as notas de fundo com \u00e2mbar podem persistir por mais de 24h \u2014 ideal para manter um rastro sutil o dia todo.'
},
{
q: 'Em qual esta\u00e7\u00e3o e ocasi\u00e3o usar o Hayat?',
a: 'Primavera e ver\u00e3o s\u00e3o ideais. As notas frutais e o brilho c\u00edtrico pedem calor e luz. Perfeito para o trabalho, passeios casuais, brunches e encontros diurnos \u2014 qualquer ocasi\u00e3o que pe\u00e7a uma fragr\u00e2ncia alegre e sofisticada.'
},
{
q: 'Hayat lembra alguma fragr\u00e2ncia ocidental famosa?',
a: 'Sim \u2014 o perfil frutal-cremoso lembra o universo do Lanc\u00f4me La Vie Est Belle e do Givenchy Dahlia Divin, mas com a profundidade quente do \u00e2mbar e madeiras que s\u00f3 a perfumaria \u00e1rabe entrega a esse n\u00edvel de concentra\u00e7\u00e3o.'
},
{
q: 'O que significa o nome Hayat?',
a: '"Hayat" (\u062d\u064a\u0627\u0629) em \u00e1rabe significa "Vida" \u2014 o nome captura perfeitamente a energia solar e vibrante da fragr\u00e2ncia. \u00c9 um perfume que abra\u00e7a como um raio de sol, cheio de vitalidade.'
},
{
q: 'Como potencializar a dura\u00e7\u00e3o do Hayat?',
a: 'Aplique em pele hidratada \u2014 o \u00f3leo ret\u00e9m a fragr\u00e2ncia por mais tempo. Borrife no pesco\u00e7o, pulsos e parte interna dos cotovelos. N\u00e3o esfregue os pulsos ap\u00f3s aplicar, pois isso quebra as mol\u00e9culas superiores e reduz a dura\u00e7\u00e3o.'
}
],
'perfil-olfativo-aser': [
{
q: 'O Aser \u00e9 um "perfume azul" \u2014 o que isso significa na pr\u00e1tica?',
a: 'Perfumes "azuis" combinam frescor c\u00edtrico ou aqu\u00e1tico com uma base amadeirada sensual. O Aser abre com bergamota e hortel\u00e3 (frescor limpo), mas fecha com Ambroxan, patchouli e vetiver \u2014 uma base densa e magn\u00e9tica. Essa dualidade \u00e9 a assinatura dos azuis: parece fresco, mas seduz pela profundidade.'
},
{
q: 'O que \u00e9 Ambroxan e por que ele torna o Aser t\u00e3o especial?',
a: 'Ambroxan \u00e9 uma mol\u00e9cula derivada do \u00e2mbar cinzento. \u00c9 o ingrediente secreto por tr\u00e1s do Dior Sauvage e do Valentino Eros. No Aser, ela confere aquela aura "limpa mas magn\u00e9tica" \u2014 presente sem agredir. \u00c9 o que faz pessoas ao redor perguntarem qual perfume voc\u00ea usa.'
},
{
q: 'Qual a dura\u00e7\u00e3o e proje\u00e7\u00e3o do Aser?',
a: 'Alta longevidade: 10\u201314h na pele. A proje\u00e7\u00e3o (sillage) \u00e9 marcante \u2014 o Aser projeta a cerca de 1m de dist\u00e2ncia, especialmente nas primeiras 2\u20133h. Na roupa, o ambroxan + vetiver podem durar dias.'
},
{
q: 'O Aser \u00e9 masculino ou pode ser usado por mulheres?',
a: '\u00c9 predominantemente masculino pelo car\u00e1ter arom\u00e1tico-amadeirado, mas mulheres que gostam de fragr\u00e2ncias unissex de car\u00e1ter forte adoram. O apelo \u00e9 similar ao do Sauvage da Dior, que tamb\u00e9m cruza fronteiras de g\u00eanero naturalmente.'
},
{
q: 'Em quais ocasi\u00f5es o Aser brilha mais?',
a: 'Perfeito para o trabalho executivo (usado com 2 borrifadas), jantares, festas ou eventos onde voc\u00ea quer ser notado pelo bom gosto. \u00c9 um "coringa de luxo": fresco o suficiente para o dia, denso e atraente o suficiente para a noite.'
},
{
q: 'Com que fragr\u00e2ncia ocidental o Aser pode ser comparado?',
a: 'O Aser remete ao universo do Dior Sauvage EDP e do YSL Y EDP, mas com mais profundidade amadeirada na base. O patchouli e vetiver presentes no DNA da perfumaria \u00e1rabe d\u00e3o ao Aser uma complexidade que esses ocidentais n\u00e3o t\u00eam.'
},
{
q: 'Por que o frasco do Aser tem um cristal azul na tampa?',
a: 'O design reflete a alma da fragr\u00e2ncia: o azul meia-noite do frasco simboliza eleg\u00e2ncia noturna e o cristal azul representa o brilho da bergamota da Cal\u00e1bria na abertura. \u00c9 uma obra de arte que comunica o perfume antes mesmo de voc\u00ea abrir o frasco.'
}
],
'perfil-olfativo-mawj': [
{
q: 'Como descrever o aroma do Mawj para quem nunca cheirou?',
a: 'Imagine estar \u00e0 beira-mar, com um drinque gelado de lim\u00e3o na m\u00e3o. O Mawj abre com Lim\u00e3o Tahiti, bergamota e hortel\u00e3 \u2014 uma explos\u00e3o gelada. O cora\u00e7\u00e3o traz notas oce\u00e2nicas com gengibre suave. O fundo \u00e9 cremoso: s\u00e2ndalo e coco fecham como lo\u00e7\u00e3o solar luxuosa. Uma viagem sensorial tropical em um frasco.'
},
{
q: 'O Mawj \u00e9 realmente unissex?',
a: 'Sim, totalmente. Fragr\u00e2ncias aqu\u00e1tico-c\u00edtricas n\u00e3o t\u00eam marcadores de g\u00eanero definidos. O frescor do lime \u00e9 moderno e universal. Funciona igualmente bem em homens e mulheres \u2014 um dos poucos perfumes da linha onde n\u00e3o existe "lado certo".'
},
{
q: 'O Mawj dura quanto tempo? Frutais costumam evaporar r\u00e1pido...',
a: 'Essa \u00e9 a vantagem do EDP \u00e1rabe: o Mawj tem concentra\u00e7\u00e3o mais alta que EDTs ocidentais equivalentes. A dura\u00e7\u00e3o \u00e9 de 6\u20138h na pele. O cedro e alm\u00edscar da base ancoram o perfume e o fundo mant\u00e9m presen\u00e7a suave ao longo do dia \u2014 sem o "desaparecimento" comum em perfumes aqu\u00e1ticos baratos.'
},
{
q: 'Qual a melhor \u00e9poca do ano para usar o Mawj?',
a: 'Ver\u00e3o \u00e9 o destino natural, mas em cidades quentes como S\u00e3o Paulo e Rio de Janeiro, o Mawj funciona bem o ano todo. Em ambientes com ar condicionado intenso, o frescor fica ainda mais pronunciado e agrad\u00e1vel.'
},
{
q: 'O Mawj \u00e9 adequado para uma ocasi\u00e3o formal?',
a: '\u00c9 mais adequado para ocasi\u00f5es casuais: praia, clube, passeios, trabalho em ambiente descontra\u00eddo. Para jantares formais, eventos de gala ou noites especiais, os perfumes Faris, Naya ou Khayal t\u00eam a sofistica\u00e7\u00e3o e presen\u00e7a necess\u00e1rias.'
},
{
q: 'Por que o nome Mawj?',
a: '"Mawj" (\u0645\u0648\u062c) significa "onda" em \u00e1rabe \u2014 perfeitamente escolhido para uma fragr\u00e2ncia que evoca o mar, o movimento da \u00e1gua e o frescor da brisa. O nome e o perfume contam a mesma hist\u00f3ria.'
},
{
q: 'O Mawj lembra alguma fragr\u00e2ncia conhecida?',
a: 'A combina\u00e7\u00e3o de c\u00edtrico + notas oce\u00e2nicas remete ao universo do Acqua di Gi\u00f2 da Armani, mas o Mawj tem um toque tropical mais quente: o coco e s\u00e2ndalo na base o tornam mais sensual e \u00fanico no drydown, diferente do aqu\u00e1tico "gen\u00e9rico" ocidental.'
}
],
'perfil-olfativo-naya': [
{
q: 'O que torna o Naya diferente de todos os outros perfumes do mercado?',
a: 'O uso de \u00c2mbar Cinzento (Ambergris) no cora\u00e7\u00e3o \u2014 um dos ingredientes mais raros da perfumaria de luxo, origin\u00e1rio do cachalote. Essa nota confere uma profundidade salina-adocicada \u00fanica, imposs\u00edvel de replicar fielmente com materiais sint\u00e9ticos baratos. O Naya \u00e9 uma experi\u00eancia olfativa aut\u00eantica de nicho.'
},
{
q: 'O Naya \u00e9 pesado para usar no dia a dia?',
a: 'Tem presen\u00e7a forte, mas o a\u00e7afr\u00e3o na abertura traz um brilho solar que alivia o peso das resinas. Com 1\u20132 borrifadas, funciona no dia a dia. Com 3+, \u00e9 uma declara\u00e7\u00e3o. N\u00e3o \u00e9 sufocante \u2014 \u00e9 "presen\u00e7a marcante" bem calibrada.'
},
{
q: 'Qual a dura\u00e7\u00e3o do Naya?',
a: 'Fragr\u00e2ncias com ambergris, Resina de Abeto e cedro t\u00eam alt\u00edssima fixa\u00e7\u00e3o. Espere 12\u201316h na pele e marcas profundas na roupa por dias. Das fragr\u00e2ncias da Niche Avenue, o Naya est\u00e1 entre as mais longevas \u2014 a resina "ancora" o perfume na pele.'
},
{
q: 'O Naya \u00e9 melhor de dia ou de noite?',
a: 'Definitivamente noturno. O car\u00e1ter ambarado e resinoso pede luz de vela, eventos elegantes ou encontros especiais. Durante o dia pode ser intenso demais para ambientes fechados. No inverno frio, funciona excepcionalmente bem no per\u00edodo diurno tamb\u00e9m.'
},
{
q: 'Para quem \u00e9 o Naya?',
a: 'Para mulheres que querem ser inesquec\u00edveis. Que preferem ser sentidas quando entram em um ambiente e lembradas depois que saem. N\u00e3o \u00e9 para quem busca algo discreto \u2014 o Naya \u00e9 uma declara\u00e7\u00e3o de sofistica\u00e7\u00e3o, riqueza e modernidade.'
},
{
q: 'O Naya \u00e9 compar\u00e1vel a alguma fragr\u00e2ncia de luxo ocidental?',
a: 'Tem semelhan\u00e7as estruturais com o Baccarat Rouge 540 da Maison Francis Kurkdjian pelo uso de ambergris e resinas, mas a uma fra\u00e7\u00e3o do pre\u00e7o. \u00c9 o nicho \u00e1rabe no seu melhor: ingredientes de alta qualidade sem o markup de marketing das grifes europeias.'
},
{
q: 'Como usar o Naya com modera\u00e7\u00e3o sem perder a ess\u00eancia?',
a: '2 borrifadas s\u00e3o suficientes em dias frios. No ver\u00e3o, prefira 1\u20132 longe do pesco\u00e7o para n\u00e3o sobrecarregar. O Naya amplifica naturalmente com o calor do corpo \u2014 menos \u00e9 mais, especialmente nos primeiros usos.'
}
],
'perfil-olfativo-haneen': [
{
q: 'O que \u00e9 Cashmeran e como ele transforma o Haneen?',
a: 'Cashmeran \u00e9 uma mol\u00e9cula especial da IFF que evoca a textura do cashmere \u2014 macia, aveludada, levemente amadeirada. No Haneen, ele transforma o buqu\u00ea floral em algo que "abra\u00e7a a pele" ao inv\u00e9s de apenas flutuar. \u00c9 o segredo do rastro sedoso e irresist\u00edvel que o Haneen deixa nas roupas e no ar.'
},
{
q: 'Qual a diferen\u00e7a entre Rosa Turca e Rosa comum em perfumaria?',
a: 'A Rosa Turca (cultivada na regi\u00e3o de Isparta, Turquia) tem um perfil mais rico: toques de mel, damasco e cera de abelha, diferente da rosa sint\u00e9tica gen\u00e9rica usada em fragr\u00e2ncias de massa. Essa escolha eleva o Haneen a um floral de nicho aut\u00eantico \u2014 voc\u00ea sente a diferen\u00e7a na pele.'
},
{
q: 'O Haneen \u00e9 um perfume jovem ou mais maduro?',
a: '\u00c9 um dos mais modernos e jovens da linha. O frescor de lichia e ruibarbo na abertura \u00e9 trendy e atual. Funciona muito bem de 18 a 40 anos \u2014 n\u00e3o tem o car\u00e1ter "cl\u00e1ssico pesado" de florais mais antigos. \u00c9 o floral \u00e1rabe do s\u00e9culo XXI.'
},
{
q: 'Quando usar o Haneen?',
a: 'Primavera, tardes ensolaradas, almo\u00e7os especiais, encontros rom\u00e2nticos e dias de trabalho onde voc\u00ea quer se sentir elegante. \u00c9 vers\u00e1til para qualquer ocasi\u00e3o diurna ou semi-formal. Evite ocasi\u00f5es pesadas e formais noturnas \u2014 para isso, prefira o Naya ou Khayal.'
},
{
q: 'O Haneen lembra algum perfume de grife?',
a: 'Muito pr\u00f3ximo ao universo do Miss Dior Blooming Bouquet e do Lanc\u00f4me La Nuit Tr\u00e9sor \u2014 florais frutados gourmet com acabamento almiscarado de luxo. Mas com uma riqueza de notas que s\u00f3 a perfumaria \u00e1rabe oferece nessa faixa de pre\u00e7o.'
},
{
q: 'Qual a dura\u00e7\u00e3o e proje\u00e7\u00e3o do Haneen?',
a: '8\u201312h na pele. A proje\u00e7\u00e3o \u00e9 moderada a alta \u2014 elegante e percebida a cerca de 50cm\u20131m, sem invadir espa\u00e7os alheios. O Cashmeran e a Baunilha na base garantem um rastro aveludado que persiste sutilmente mesmo horas depois.'
},
{
q: 'O nome Haneen tem algum significado especial?',
a: '"Haneen" (\u062d\u0646\u064a\u0646) em \u00e1rabe significa "saudade" ou "nostalgia suave" \u2014 essa emo\u00e7\u00e3o delicada e calorosa est\u00e1 perfeitamente capturada na fragr\u00e2ncia: um buqu\u00ea floral que reconforta como uma mem\u00f3ria feliz.'
}
],
'perfil-olfativo-noor': [
{
q: 'O que diferencia o Noor de outros florais brancos no mercado?',
a: 'A presen\u00e7a da Tuberosa \u2014 uma das flores mais dif\u00edceis de extrair e mais luxuosas da perfumaria. Ela confere ao Noor um car\u00e1ter cremoso e levemente narc\u00f3tico que transforma um simples floral branco em algo sofisticado. A Tuberosa \u00e9 usada em perfumes como Fracas, Carnal Flower (Fr\u00e9d\u00e9ric Malle) e Tub\u00e9reuse Criminelle (Serge Lutens).'
},
{
q: 'O Noor \u00e9 muito pesado para uso di\u00e1rio?',
a: 'N\u00e3o \u2014 apesar de ter Tuberosa e Patchouli, o Alm\u00edscar Branco e a abertura com p\u00eara e bergamota criam leveza surpreendente. \u00c9 um branco luminoso, n\u00e3o opressivo. Com 2 borrifadas, \u00e9 perfeito para o dia a dia. Com 3\u20134, para ocasi\u00f5es especiais.'
},
{
q: 'Noor \u00e9 melhor de dia ou de noite?',
a: 'Funciona nos dois. De dia: elegante e discreto, como uma segunda pele. \u00c0 noite: com o aquecimento do corpo, a Tuberosa e o Patchouli se intensificam, criando uma aura mais sensual. \u00c9 um dos perfumes mais "camale\u00e3o" da cole\u00e7\u00e3o.'
},
{
q: 'Qual a dura\u00e7\u00e3o do Noor?',
a: 'Patchouli e Alm\u00edscar Branco t\u00eam alt\u00edssima fixa\u00e7\u00e3o. Espere 10\u201314h de dura\u00e7\u00e3o na pele e notas de fundo durando muito mais na roupa. \u00c9 um dos mais duradouros da linha para fragr\u00e2ncias florais.'
},
{
q: 'O que significa o nome Noor?',
a: '"Noor" (\u0646\u0648\u0631) significa "Luz" em \u00e1rabe \u2014 o nome reflete a luminosidade da fragr\u00e2ncia: flores brancas brilhantes, p\u00eara cristalina e o rastro limpo do alm\u00edscar. \u00c9 literalmente a fragr\u00e2ncia da luz.'
},
{
q: 'Noor se compara a algum perfume de luxo ocidental?',
a: 'Tem DNA similar ao Chance Eau Tendre da Chanel (floral branco almiscarado), mas com a riqueza do Jasmim \u00e1rabe de alta qualidade e a profundidade do Patchouli tornando-o mais complexo e duradouro. \u00c9 o Chanel de luxo \u00e1rabe.'
},
{
q: 'Posso usar o Noor no ambiente de trabalho?',
a: 'Sim \u2014 \u00e9 discreto o suficiente para ambientes profissionais com 2 borrifadas. A sillage \u00e9 elegante e n\u00e3o invasiva. \u00c9 uma \u00f3tima escolha para o trabalho, onde voc\u00ea quer transmitir cuidado pessoal sem distrair os colegas.'
}
],
'perfil-olfativo-hadi': [
{
q: 'Por que o Hadi \u00e9 chamado de "perfume dos elogios"?',
a: 'A combina\u00e7\u00e3o de Cardamomo + Abacaxi no cora\u00e7\u00e3o e Castanha Caramelizada na base cria um sillage irresist\u00edvel e inesperado. N\u00e3o \u00e9 um perfume \u00f3bvio \u2014 ele surpreende. Quem o sente pergunta automaticamente "o que \u00e9 esse perfume?". Isso \u00e9 intencional na estrutura olfativa do Hadi.'
},
{
q: 'O que \u00e9 a Castanha Caramelizada no fundo do Hadi?',
a: 'Um ingrediente gourmet incomum em perfumaria: quente, doce e amadeirado, similar ao accord de pralin\u00ea usado em fragr\u00e2ncias como 1 Million da Paco Rabanne, mas com mais eleg\u00e2ncia. \u00c9 o que d\u00e1 ao Hadi esse final "comest\u00edvel" sofisticado que gruda na mem\u00f3ria de quem sente.'
},
{
q: 'O Hadi tem longevidade adequada para o dia todo?',
a: 'Sim \u2014 a base de Castanha, Baunilha, \u00c2mbar e Cedro garante 10\u201312h na pele. \u00c9 considerado um dos mais duradouros da cole\u00e7\u00e3o Niche Avenue. Na roupa, o rastro pode persistir 24h+.'
},
{
q: 'Em quais ocasi\u00f5es o Hadi \u00e9 mais indicado?',
a: '\u00c9 extremamente vers\u00e1til: funciona no trabalho, em baladas, jantares, encontros rom\u00e2nticos e at\u00e9 no dia a dia casual. No outono e inverno, as notas caramelizadas se desenvolvem melhor com o frio. No ver\u00e3o, aplique com modera\u00e7\u00e3o \u2014 a do\u00e7ura amplifica com o calor.'
},
{
q: 'O Hadi lembra qual fragr\u00e2ncia ocidental?',
a: 'Tem similaridades com 1 Million da Paco Rabanne e Eros Flame da Valentino pela f\u00f3rmula "frescor + do\u00e7ura + sedu\u00e7\u00e3o", mas com especiarias \u00e1rabes \u2014 cardamomo, pimenta rosa e s\u00e1lvia \u2014 tornando-o muito mais complexo e sofisticado que esses perfumes ocidentais.'
},
{
q: 'O Hadi \u00e9 s\u00f3 masculino ou qualquer pessoa pode usar?',
a: '\u00c9 predominantemente masculino, mas mulheres que gostam de perfumes doces-especiados (gourmand) adoram o Hadi. A do\u00e7ura da castanha e baunilha tem apelo universal. N\u00e3o existe uma regra r\u00edgida em perfumaria \u00e1rabe \u2014 o aroma fala por si.'
},
{
q: 'O nome Hadi tem algum significado?',
a: '"Hadi" (\u0647\u0627\u062f\u064a) em \u00e1rabe significa "calmo", "sereno" ou "guia". O perfume captura essa dualidade: aparentemente tranquilo na sa\u00edda, mas com uma presen\u00e7a magn\u00e9tica que guia os olhares na dire\u00e7\u00e3o de quem o usa.'
}
],
'perfil-olfativo-sama': [
{
q: 'Qual a diferen\u00e7a entre o Sama e o Mawj, j\u00e1 que ambos s\u00e3o frescos?',
a: 'O Mawj \u00e9 tropical e festivo: coco, lime, oce\u00e2nico + sensual. O Sama \u00e9 mais a\u00e9reo e "ar puro" \u2014 como uma brisa de montanha ao inv\u00e9s de praia. O Sama tem Jasmim e Folhas de Ch\u00e1 no cora\u00e7\u00e3o, tornando-o mais sofisticado para uso di\u00e1rio. Mawj \u00e9 ver\u00e3o; Sama \u00e9 leveza o ano todo.'
},
{
q: 'O Sama parece simples \u2014 ele tem complexidade de verdade?',
a: 'A primeira borrifada \u00e9 enganosamente simples (c\u00edtrico limpo), mas o cora\u00e7\u00e3o com Folhas de Ch\u00e1 e Pimenta Rosa traz surpreendente complexidade. O fundo com Cedro e resinas leves garante que o Sama n\u00e3o "desapare\u00e7a" \u2014 ele fica, discretamente, como uma presen\u00e7a confort\u00e1vel.'
},
{
q: 'O Sama \u00e9 adequado para o ambiente de trabalho?',
a: '\u00c9 um dos mais indicados para o trabalho de toda a cole\u00e7\u00e3o \u2014 discreto, limpo, profissional, sem incomodar colegas em ambientes fechados. Transmite cuidado pessoal sem declarar presen\u00e7a excessiva. Ideal para reuni\u00f5es, escrit\u00f3rios e qualquer ambiente corporativo.'
},
{
q: 'O Sama pode ser um perfume para usar todos os dias?',
a: 'Exatamente para isso ele foi criado. \u00c9 um perfume "de bancada" \u2014 voc\u00ea o coloca sem pensar duas vezes. No ver\u00e3o refresca; no inverno, as resinas do fundo aquecem e confortam. Baixo comprometimento, alto prazer di\u00e1rio.'
},
{
q: 'Quanto tempo o Sama dura?',
a: 'Por ser aqu\u00e1tico-c\u00edtrico, a abertura dissipa mais r\u00e1pido (1\u20132h de sillage intenso), mas o Alm\u00edscar Branco e o Cedro da base mant\u00eam uma presen\u00e7a suave por 6\u201310h no total. O drydown \u00e9 o ponto mais elegante do Sama.'
},
{
q: 'O que significa o nome Sama?',
a: '"Sama" (\u0633\u0645\u0627\u0621) em \u00e1rabe significa "C\u00e9u" \u2014 a fragr\u00e2ncia \u00e9 literalmente o aroma da imensid\u00e3o azul: limpa, aberta e luminosa. Usar o Sama \u00e9 sentir como se voc\u00ea tivesse trazido um pouco do c\u00e9u para a pele.'
},
{
q: 'O Sama \u00e9 bom para homens e mulheres?',
a: '\u00c9 um dos mais unissex da cole\u00e7\u00e3o. O equil\u00edbrio entre o Jasmim (mais feminino), a Pimenta Rosa (neutra) e o Cedro (mais masculino) faz do Sama um perfume que qualquer pessoa pode usar com igual eleg\u00e2ncia e confian\u00e7a.'
}
],
'perfil-olfativo-faris': [
{
q: 'Por que o Faris \u00e9 considerado o mais "gentleman" da linha?',
a: 'A combina\u00e7\u00e3o de Lavanda e Zimbro na abertura, com Ger\u00e2nio e Coentro no cora\u00e7\u00e3o, forma um DNA arom\u00e1tico que \u00e9 sin\u00f4nimo de masculinidade cl\u00e1ssica e refinada. O fundo de S\u00e2ndalo e Vetiver adiciona a complexidade de um homem experiente. \u00c9 sofisticado sem precisar gritar.'
},
{
q: 'O que \u00e9 Zimbro (Juniper Berries) em um perfume?',
a: 'O zimbro adiciona um frescor quase "gim-like" \u2014 seco, vegetal e ligeiramente resinoso. \u00c9 o que d\u00e1 ao Faris aquela "aresta elegante" na abertura antes da cremosidade amadeirada tomar conta. \u00c9 um ingrediente raro em perfumes populares, que eleva o Faris a um n\u00edvel nicho genu\u00edno.'
},
{
q: 'O Faris tem sillage forte ou mais pr\u00f3ximo \u00e0 pele?',
a: 'Moderado a marcante. A Lavanda e os C\u00edtricos no topo s\u00e3o suaves e elegantes. O fundo com Patchouli e Vetiver cria um rastro que persiste por horas \u2014 percebido a cerca de 50cm\u20131m. \u00c9 elegante, nunca agressivo. Perfeito para quem quer presen\u00e7a sem exagero.'
},
{
q: 'Por quanto tempo o Faris dura?',
a: 'S\u00e2ndalo, Patchouli e Vetiver s\u00e3o conhecidos pelo alt\u00edssimo poder de fixa\u00e7\u00e3o. Espere 10\u201314h na pele. Na roupa \u2014 especialmente em tecidos naturais como linho e algod\u00e3o \u2014 pode durar mais de 24h com as notas de fundo intactas.'
},
{
q: 'Qual a melhor esta\u00e7\u00e3o para o Faris?',
a: 'Outono e inverno \u2014 a cremosidade do s\u00e2ndalo e o calor do \u00e2mbar ficam ainda mais confort\u00e1veis em dias frios. Na primavera tamb\u00e9m funciona excelentemente. No ver\u00e3o intenso, prefira menos borrifadas (1\u20132 no m\u00e1ximo).'
},
{
q: 'O Faris lembra algum perfume ocidental de luxo?',
a: 'Tem similaridades com Bleu de Chanel EDP e Cartier D\u00e9claration pelo car\u00e1ter arom\u00e1tico-amadeirado-especiado. Mas o Faris tem a cremosidade extra do S\u00e2ndalo \u00e1rabe e a profundidade do Vetiver tornando-o mais rico e complexo do que esses cl\u00e1ssicos ocidentais.'
},
{
q: 'O que significa o nome Faris?',
a: '"Faris" (\u0641\u0627\u0631\u0633) significa "Cavaleiro" em \u00e1rabe \u2014 a fragr\u00e2ncia \u00e9 a personifica\u00e7\u00e3o de um cavaleiro nobre: forte na base amadeirada, elegante no cora\u00e7\u00e3o especiado, nobre na presen\u00e7a. Um perfume com car\u00e1ter e hist\u00f3ria.'
}
],
'perfil-olfativo-khayal': [
{
q: 'O que \u00e9 Oud e por que ele \u00e9 t\u00e3o especial no Khayal?',
a: 'Oud (Madeira de Agar) \u00e9 formado quando a \u00e1rvore Aquilaria \u00e9 infectada por um fungo espec\u00edfico \u2014 a rea\u00e7\u00e3o cria uma resina extraordin\u00e1ria. A madeira resultante \u00e9 t\u00e3o rara que chega a valer mais que ouro por peso. No Khayal, o Oud foi trabalhado de forma elegante: terroso, profundo e levemente adocicado, sem o lado "medicinal" que afasta iniciantes.'
},
{
q: 'O Khayal \u00e9 para quem est\u00e1 come\u00e7ando na perfumaria \u00e1rabe?',
a: '\u00c9 o mais "expert" da cole\u00e7\u00e3o \u2014 genu\u00edno para quem j\u00e1 ama nicho e Oud. Se voc\u00ea est\u00e1 come\u00e7ando, recomendamos iniciar com Aser, Hadi ou D\'ahab para treinar o olfato antes do Khayal. Mas se voc\u00ea j\u00e1 ama Oud ou incenso, o Khayal ser\u00e1 amor imediato e irrevers\u00edvel.'
},
{
q: 'O Khayal cheira a fuma\u00e7a ou incenso de forma intensa?',
a: 'N\u00e3o \u00e9 um "fumey" extremo. A combina\u00e7\u00e3o de Oud + Patchouli + Couro cria uma sensa\u00e7\u00e3o de madeira queimada muito suave e sofisticada \u2014 como estar em um pal\u00e1cio \u00e1rabe com lareira de madeira nobre, n\u00e3o em um templo com incenso sagrado pesado. \u00c9 elegante e controlado.'
},
{
q: 'Qual a longevidade do Khayal?',
a: '\u00c9 provavelmente o mais duradouro de toda a linha Niche Avenue. Oud, Couro e Alm\u00edscar criam uma fixa\u00e7\u00e3o extraordin\u00e1ria: 14\u201318h na pele. A roupa guarda o aroma por dias. As primeiras 2h s\u00e3o intensas; depois, ele "acalma" e se funde \u00e0 pele como uma segunda natureza.'
},
{
q: 'O Khayal \u00e9 masculino ou feminino?',
a: 'No Oriente M\u00e9dio, Oud \u00e9 usado por homens e mulheres igualmente \u2014 n\u00e3o existe g\u00eanero para incenso e resinas. No Brasil, \u00e9 percebido como mais masculino pelo car\u00e1ter pesado. Mas qualquer pessoa ousada e apreciadora de nicho genu\u00edno pode e deve usar o Khayal com orgulho.'
},
{
q: 'O Khayal pode ser comparado a algum nicho ocidental?',
a: 'Tem similaridades com Tom Ford Oud Wood e Initio Oud for Greatness pelo car\u00e1ter amadeirado-resinoso. Mas o Khayal carrega a autenticidade \u00e1rabe que nenhum nicho ocidental consegue replicar completamente \u2014 o Oud \u00e1rabe tem uma alma que os perfumistas europeus ainda perseguem.'
},
{
q: 'O que significa o nome Khayal?',
a: '"Khayal" (\u062e\u064a\u0627\u0644) em \u00e1rabe significa "imagina\u00e7\u00e3o" ou "fantasia". O perfume foi concebido para transportar quem o usa para um universo sensorial diferente \u2014 como entrar em um sonho olfativo de luxo e mist\u00e9rio oriental.'
}
],
'perfil-olfativo-ameer': [
{
q: 'O que \u00e9 Fava Tonka e como ela enriquece o Ameer?',
a: 'Fava Tonka \u00e9 uma semente da Am\u00e9rica do Sul com um aroma que mescla Baunilha, am\u00eandoa torrada e caramelo. No Ameer, ela suaviza o especiado da Canela e do Cominho, criando um fundo extremamente cremoso e envolvente. \u00c9 o ingrediente que transforma o Ameer de "especiado" para "princ\u00edpio irresist\u00edvel".'
},
{
q: 'Por que o Cominho no cora\u00e7\u00e3o do Ameer? N\u00e3o vai cheirar a comida?',
a: 'Em perfumaria, o Cominho n\u00e3o tem o papel culin\u00e1rio que tem na cozinha. Aqui ele cria um calor corporal sutil \u2014 quente e levemente animal, como a pele aquecida de uma pessoa. \u00c9 um ingrediente tradicional da perfumaria \u00e1rabe que d\u00e1 ao Ameer uma autenticidade oriental genu\u00edna.'
},
{
q: 'O Ameer funciona para quais ocasi\u00f5es?',
a: '\u00c9 vers\u00e1til: outono e inverno s\u00e3o ideais. Funciona no trabalho com 2 borrifadas, em encontros rom\u00e2nticos e eventos noturnos. A abertura de Hortel\u00e3 + Lavanda \u00e9 fresca o suficiente para n\u00e3o "pesar" cedo, enquanto o fundo com S\u00e2ndalo e Tonka projeta sofistica\u00e7\u00e3o.'
},
{
q: 'Qual a dura\u00e7\u00e3o do Ameer?',
a: 'S\u00e2ndalo, Fava Tonka e Cedro garantem 10\u201314h de dura\u00e7\u00e3o. A proje\u00e7\u00e3o \u00e9 moderada a alta \u2014 elegante e presente sem ser invasiva. Um dos mais equilibrados da cole\u00e7\u00e3o entre performance e versatilidade.'
},
{
q: 'O Ameer se compara a alguma fragr\u00e2ncia de grife ocidental?',
a: 'Tem DNA similar ao Spicebomb Extreme de Viktor\u0026Rolf e ao Stronger With You de Emporio Armani \u2014 especiados + doces + amadeirados. Mas com a profundidade do S\u00e2ndalo indiano e a autenticidade do Cominho \u00e1rabe, o Ameer oferece complexidade superior a um pre\u00e7o mais justo.'
},
{
q: 'O frasco com o s\u00edmbolo do cavalo \u2014 o que representa?',
a: 'O cavalo \u00e9 o s\u00edmbolo do esp\u00edrito \u00e1rabe cl\u00e1ssico: liberdade, nobreza e for\u00e7a. O frasco preto com ranhuras verticais e o selo dourado do cavalo comunicam que o Ameer \u00e9 um perfume de car\u00e1ter e heran\u00e7a \u2014 um pr\u00edncipe que conhece suas origens.'
},
{
q: '"Ameer" significa Pr\u00edncipe \u2014 o perfume entrega essa promessa?',
a: 'Totalmente. A dualidade entre o frescor da Hortel\u00e3 (energia jovem e vibrante) e a riqueza do S\u00e2ndalo + Baunilha (nobreza amadurecida) realmente transmite a imagem de um pr\u00edncipe moderno: sofisticado sem ser pomposo, forte sem ser agressivo.'
}
],
'perfil-olfativo-fahed': [
{
q: 'O que torna o Fahed t\u00e3o impactante desde a primeira borrifada?',
a: 'A combina\u00e7\u00e3o incomum de Pimenta Preta + Cardamomo na abertura cria uma assinatura imediata: seco, picante e penetrante. O Fahed n\u00e3o pede licen\u00e7a para entrar em um ambiente \u2014 ele se anuncia. \u00c9 uma fragr\u00e2ncia para quem quer ser percebido antes de abrir a boca.'
},
{
q: 'O Couro no fundo do Fahed \u00e9 aut\u00eantico? Como \u00e9 esse aroma?',
a: 'Em perfumaria moderna, "couro" \u00e9 um accord sofisticado de mol\u00e9culas que evoca couro tratado. No Fahed, \u00e9 rico e animal sem ser desagrad\u00e1vel \u2014 como couro italiano de alta qualidade, n\u00e3o borracha. Associado ao Vetiver e ao \u00c2mbar Escuro, cria uma aura animal e elegante simultaneamente.'
},
{
q: 'O Incenso do Fahed \u00e9 pesado como em uma igreja ou templo?',
a: 'N\u00e3o \u2014 \u00e9 equilibrado e solar. O Cedro e o A\u00e7afr\u00e3o ao redor do Incenso suavizam o tom sagrado, tornando-o mais met\u00e1lico e luxuoso do que pesado. Pessoas que n\u00e3o gostam de incenso puro geralmente adoram como ele aparece no Fahed \u2014 presente mas nunca dominante.'
},
{
q: 'Para quais ocasi\u00f5es o Fahed \u00e9 mais indicado?',
a: 'Noturno por excel\u00eancia. Festas, eventos formais, jantares especiais, encontros \u00edntimos. \u00c9 um perfume de "grande ocasi\u00e3o" \u2014 usar Fahed no supermercado seria como usar um terno Armani para fazer compras. Ele merece a noite.'
},
{
q: 'Quanto tempo o Fahed dura na pele?',
a: 'Couro + Vetiver + \u00c2mbar Escuro formam uma tr\u00edade de ultra-fixa\u00e7\u00e3o. Espere 12\u201316h na pele e marcas profundas na roupa. Na gravata, no casaco ou no len\u00e7o, o rastro do Fahed pode durar 2\u20133 dias. \u00c9 um dos mais persistentes da cole\u00e7\u00e3o Niche Avenue.'
},
{
q: 'Por que o nome Fahed \u2014 Leopardo?',
a: '"Fahed" (\u0641\u0647\u062f) literalmente significa "Leopardo" em \u00e1rabe. O perfume foi criado para refletir essa personalidade: \u00e1gil na abertura picante, poderoso no corpo especiado-incensado e profundo no rastro de couro. Um depredador elegante que voc\u00ea respeita por instinto.'
},
{
q: 'O Fahed tem compar\u00e1vel no nicho ocidental?',
a: 'Tom Ford Black Orchid e Roja Dove Enigma t\u00eam DNA similar pelo triptych couro + especiarias + incenso. Mas o Fahed carrega o a\u00e7afr\u00e3o \u00e1rabe genu\u00edno que os ocidentais raramente acertam \u2014 \u00e9 aut\u00eantico onde os europeus s\u00e3o interpretativos.'
}
],
'perfil-olfativo-dahab': [
{
q: 'O que torna o D\'ahab \u00fanico entre os perfumes frutados do mercado?',
a: 'A escolha do Maracuj\u00e1 no cora\u00e7\u00e3o \u2014 tropical, levemente \u00e1cido e ex\u00f3tico \u2014 combinado com Coentro (que adiciona um toque especiado herbal) \u00e9 altamente incomum. N\u00e3o \u00e9 um frutal gen\u00e9rico. \u00c9 um frutal tropical com alma \u00e1rabe: doce, quente e com profundidade.'
},
{
q: 'Por que usar Ma\u00e7\u00e3 Granny Smith e n\u00e3o uma ma\u00e7\u00e3 comum?',
a: 'A variedade Granny Smith \u00e9 mais \u00e1cida e verde \u2014 cria um frescor diferenciado e mais vivo na abertura, menos doce e gen\u00e9rico. \u00c9 a \u00e2ncora \u00e1cida que equilibra a do\u00e7ura da Manga e do Maracuj\u00e1, evitando que o D\'ahab se torne enjoativo.'
},
{
q: 'O D\'ahab \u00e9 muito doce?',
a: 'A do\u00e7ura \u00e9 bem temperada: o Coentro (herbal) e o Cedro (amadeirado) no cora\u00e7\u00e3o seguram a do\u00e7ura dos frutos. O Patchouli na base adiciona profundidade terrosa. Resultado: um frutal sofisticado que vai de fresco e \u00e1cido a quente e sensual gradualmente \u2014 n\u00e3o enjoativo.'
},
{
q: 'Quando e como usar o D\'ahab?',
a: 'Primavera e ver\u00e3o s\u00e3o perfeitos, mas cidades quentes como SP e Rio permitem uso o ano todo. \u00c9 uma fragr\u00e2ncia festiva e alegre: noites de ver\u00e3o, happy hour, encontros descontra\u00eddos, festas ao ar livre. Um perfume que cria atmosfera positiva onde quer que voc\u00ea esteja.'
},
{
q: 'O D\'ahab tem boa durabilidade para um frutal?',
a: 'Sim \u2014 o diferencial \u00e9 o Patchouli + \u00c2mbar na base, que s\u00e3o fixadores de alta qualidade. Ao contr\u00e1rio de frutais gen\u00e9ricos que evaporam em 2h, o D\'ahab mant\u00e9m presen\u00e7a por 8\u201312h. O drydown com Patchouli \u00e9 especialmente interessante \u2014 quente e sensual.'
},
{
q: 'O que significa D\'ahab?',
a: '"Dahab" (\u0630\u0647\u0628) significa "Ouro" em \u00e1rabe. O frasco com degrad\u00ea solar de amarelo vibrante a laranjado dourado reflete isso visualmente. Uma fragr\u00e2ncia dourada, brilhante e valiosa \u2014 assim como ouro, voc\u00ea nota quando ela est\u00e1 presente.'
},
{
q: 'O D\'ahab \u00e9 masculino, feminino ou unissex?',
a: 'Totalmente unissex \u2014 a combina\u00e7\u00e3o de frutas tropicais tem apelo universal. Mulheres adoram pelo lado frutal-floral ex\u00f3tico. Homens se identificam com o toque amadeirado do Cedro e a profundidade do Patchouli na base. Em perfumaria \u00e1rabe, fragr\u00e2ncias frutadas n\u00e3o t\u00eam g\u00eanero.'
}
]
};
function buildAccordionHTML(faqs) {
var html = '';
faqs.forEach(function (item) {
html += '<details style="border-bottom:1px solid rgba(0,0,0,0.08);padding:0;">'
+ '<summary style="cursor:pointer;padding:16px 30px 16px 0;font-weight:600;font-size:14.5px;color:#222;list-style:none;-webkit-appearance:none;position:relative;line-height:1.4;">'
+ '<span class="na-faq-icon" style="position:absolute;right:4px;top:50%;transform:translateY(-50%);font-size:20px;font-weight:300;color:#888;transition:transform 0.2s;">+</span>'
+ item.q
+ '</summary>'
+ '<div style="padding:0 24px 18px 0;color:#555;font-size:14px;line-height:1.75;">' + item.a + '</div>'
+ '</details>';
});
return html;
}
function renderFAQ() {
var container = document.getElementById('na-faq-section');
if (!container) return;
var pathname = window.location.pathname;
var match = pathname.match(/\/products\/([^/?#]+)/);
var slug = match ? match[1] : '';
var faqs = FAQS[slug];
if (!faqs || !faqs.length) {
container.innerHTML = '<p style="color:#888;font-size:14px;text-align:center;">Informa\u00e7\u00f5es em breve para este produto.</p>';
return;
}
container.innerHTML = buildAccordionHTML(faqs);
container.querySelectorAll('details').forEach(function (det) {
det.addEventListener('toggle', function () {
var icon = det.querySelector('.na-faq-icon');
if (icon) icon.textContent = det.open ? '\u2212' : '+';
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', renderFAQ);
} else {
renderFAQ();
}
setTimeout(renderFAQ, 400);
})();
